<template>
  <div class="followlist">
    <div class="followlist-m">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
        @submit.native.prevent
      >
      <el-form-item label="巡更棒编号">
        <el-input
          v-model.trim="formInline.greatNo"
          placeholder="请输入巡更棒编号"
          clearable
          @keyup.enter.native.prevent="enterSearchMember"
          style="width: 150px"
        ></el-input>
      </el-form-item>
        <el-form-item label="巡更位置">
          <el-input
            v-model.trim="formInline.location"
            placeholder="请输入巡更位置"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item label="巡更时间范围">
            <el-date-picker
              v-model="formInline.timeRange"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              style="width: 240px;"
              @change="timeChange"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions">
            </el-date-picker>
          <!-- <el-date-picker
            v-model.trim="formInline.startTime"
            type="datetime"
            placeholder="选择开始日期时间"
            clearable
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 200px"
          >
          </el-date-picker> -->
        </el-form-item>
        <!-- <el-form-item label="结束时间">
          <el-date-picker
            v-model.trim="formInline.endTime"
            type="datetime"
            placeholder="选择结束日期时间"
            clearable
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 200px"
          >
          </el-date-picker>
        </el-form-item> -->
        <el-form-item label="巡更状态">
          <el-select
            v-model="formInline.status"
            placeholder="请选择"
            style="width: 140px"
            @change="onSubmit"
            clearable
          >
            <el-option label="待巡更" value="1"> </el-option>
            <el-option label="已巡更" value="2"> </el-option>
            <el-option label="超时未巡更" value="3"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            plain
            @click="onSubmit"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="info" icon="el-icon-document" plain @click="downLoad"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <div class="table-page">
          <el-table
            :data="list"
            style="width: 100%"
            :row-style="tableRowStyle"
            :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
            :header-cell-style="tableHeaderColor"
          >
            <el-table-column
              label="巡更位置"
              align="center"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.location }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="巡更人"
              align="center"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.userName }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="巡更时间"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{
                  scope.row.patrolTime.substring(5,16)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="任务开始时间"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.row.patrolStart.substring(5,16)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="任务截止时间"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.patrolEnd.substring(5,16) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="巡更棒编号"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.greatNo }}</span>
              </template>
            </el-table-column>
            <!-- <el-table-column
              label="巡更点编号"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.pointNo }}</span>
              </template>
            </el-table-column> -->
            <el-table-column
              label="实际巡更时间"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{
                  scope.row.patrolCheck
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="状态"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span
                  style="margin-left: 10px; color: #fe8282"
                  v-if="scope.row.status == 1"
                  >待巡更</span
                >
                <span
                  style="margin-left: 10px; color: #13b965"
                  v-else-if="scope.row.status == 2"
                  >已巡更</span
                >
                <span
                  style="margin-left: 10px; color: #f9bc29"
                  v-else-if="scope.row.status == 3"
                  >已超时</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
          :page-size="pageSize"
          align="center"
          class="fenye"
        ></el-pagination>
      </div>
    </div>
    <!-- 弹出新增 -->
    <el-dialog
      title="巡更提醒"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closexz"
      width="30%"
    >
      <span
        style="
          color: #09a3c1;
          display: block;
          text-align: center;
          padding-bottom: 10px;
        "
        >您还有未巡更的点,需要您去巡更</span
      >
      <el-form ref="form" :model="form">
        <el-form-item label="巡更位置" :label-width="formLabelWidth">
          <el-input v-model.trim="form.location" disabled></el-input>
        </el-form-item>
        <el-form-item label="巡更时间" :label-width="formLabelWidth">
          <el-input v-model.trim="form.patrolTime" disabled></el-input>
        </el-form-item>
        <!--
          <el-form-item label="巡更时间范围 " :label-width="formLabelWidth">
            <el-input v-model.trim="form.xzsec" disabled></el-input>
          </el-form-item>
        -->
        <el-form-item label="开始时间 " :label-width="formLabelWidth">
          <el-input v-model.trim="form.patrolStart" disabled></el-input>
        </el-form-item>
        <el-form-item label="结束时间 " :label-width="formLabelWidth">
          <el-input v-model.trim="form.patrolEnd" disabled></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="okRemind">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import iTable from "@/components/iTable.vue";
import { baseURL } from "@/utils/request.js";
export default {
  data() {
    return {
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 8, //每页显示的条数
      deviceno: "",
      list: [], //返回的结果集合
      totalDataNumber: 0, //数据的总数,
      loading: "", //加载数据中
      formInline: {
        inputdeviceno: "",
        timeRange:[]
      },
      options: {
        stripe: true, // 是否为斑马纹 table
        //loading: true, // 是否添加表格loading加载动画
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        mutiSelect: false, // 是否支持列表项选中功能
      }, // table 的参数
      columns: [
        {
          prop: "userName",
          label: "巡更人",
          align: "center",
        },
        {
          prop: "location",
          label: "巡更位置",
          align: "center",
        },
        {
          prop: "greatNo",
          label: "巡更棒编号",
          align: "center",
        },
        {
          prop: "pointNo",
          label: "巡更点编号",
          align: "center",
        },
      ], // 需要展示的列
      operates: {
        width: 0,
        fixed: "right",
        offset: 20,
        list: [],
      }, // 列操作按钮
      dialogFormVisible: false,
      form: {},
      formLabelWidth: "100px",
      objData: {},
      pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
    };
  },
  methods: {
    // 选中行
    handleSelectionChange(val) {
      console.log("val:", val);
    },
    timeChange(val){
      console.log(val);
      if (val && val.length>1) {
          let startQueryTime  = val[0].substring(0, 10) + " 00:00:00";
          let endQueryTime = val[1].substring(0, 10) + " 23:59:59";
          this.formInline.startTime = startQueryTime;
          this.formInline.endTime = endQueryTime;
      }else{
        this.formInline.startTime  = null;
        this.formInline.endTime  = null;
      }
    },
    //点击查询
    onSubmit(newVal, oldVal) {
      console.log(newVal, oldVal);
      // if (this.formInline.inputdeviceno == "") {
      //   this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
      // } else {
      this.getTableData(
        this.formInline.inputdeviceno,
        (this.pageNum = 1),
        (this.pageSize = 8)
      );
      // }
    },

    //键盘事件 按下键盘回车 查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.formInline.inputdeviceno != null) {
        // if (this.formInline.inputdeviceno == "") {
        //   this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
        // } else {
        this.getTableData(
          this.formInline.inputdeviceno,
          (this.pageNum = 1),
          (this.pageSize = 8)
        );
        // }
      }
    },
    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
    closexz() {
      this.form = {};
      // sessionStorage.getItem("objData1");
      // this.$refs.formbind.resetFields(); //移除校验结果并重置字段值
    },
    //获取表格数据
    getTableData() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        location: this.formInline.location,
        greatNo: this.formInline.greatNo,
        pointNo: this.formInline.pointNo,
        startTime: this.formInline.startTime,
        endTime: this.formInline.endTime,
        status: this.formInline.status,
      };
      console.log(param);
      this.loading = true;
      this.$postJson("dmc/patrolReminder/queryListWithPage", param).then(
        (res) => {
          console.log(res);
          //判断是否有数据
          if (res.result.list.length != 0) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.totalDataNumber = res.result.total * 1;
            this.list = res.result.list;
            //this.$set(this.tableData,res.result.list)
            console.log(this.list);
            setTimeout(() => {
              this.loading = false;
            }, 500);
          } else {
            this.list = [];
            this.totalDataNumber = 0;
            setTimeout(() => {
              this.loading = false;
            }, 3000);
          }
        }
      );
    },
    okRemind() {
      this.dialogFormVisible = false;
      // 确认之后删除数据,防止下次进来弹窗显示
      // sessionStorage.removeItem("objData1");
    },
    //模板下载
    downLoad() {
      let location = ``;
      let greatNo = ``;
      let pointNo = ``;
      let startTime = ``;
      let endTime = ``;
      let status = ``;

      if (this.formInline.location) {
        location = `&location=${this.formInline.location}`;
      }
      if (this.formInline.greatNo) {
        greatNo = `&greatNo=${this.formInline.greatNo}`;
      }
      if (this.formInline.pointNo) {
        pointNo = `&pointNo=${this.formInline.pointNo}`;
      }
      if (this.formInline.startTime) {
        startTime = `&startTime=${this.formInline.startTime}`;
      }
      if (this.formInline.endTime) {
        endTime = `&endTime=${this.formInline.endTime}`;
      }
      if (this.formInline.status) {
        status = `&status=${this.formInline.status}`;
      }
      window.location.href =
        baseURL +
        `dmc/api/patrolReminderDown?groupId=${sessionStorage.getItem(
          "groupId"
        )}${location}${greatNo}${pointNo}${startTime}${endTime}${status}`;
    },

    //初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getTableData();
    },
  },

  watch: {
    currentPage(newV, oldV) {
      console.log(newV, oldV);
      deep: true; //深度监听
    },
    //  tableData(newV,oldV) {
    //      console.log(newV,oldV);
    //      deep: true  //深度监听
    // },
    data: "onSubmit", //值可以为methods的方法
  },

  created() {
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    this.getTableData();
    var that = this;
    //监听submitFormEditchange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
    this.$bus.$on("changePatrolReminderCreate", (data) => {
      console.log("11111111");
      console.log(data, "11111111");
      // console.log(this.$route.query.objData, "11111111this.$route.query.objData;this.$route.query.objData;");
      // this.dialogFormVisible = false
      // 每次点击进来初始化数据,弹出弹窗
      this.objData = data;
      this.form = Object.assign({}, JSON.parse(data.content));
      // that.dialogFormVisible = true;
      setTimeout(() => {
        that.dialogFormVisible = true;
      }, 1000);
      // this.dialogFormVisible = true;
      console.log(that.dialogFormVisible);
    });
  },

  mounted() {
    //监听submitFormchange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
    this.$bus.$on("submitFormchange_follow", () => {
      this.getTableData();
    }),
      //监听handleDeletechange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
      this.$bus.$on("handleDeletechange_follow", () => {
        this.getTableData();
      }),
      //监听submitFormEditchange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
      this.$bus.$on("submitFormEditchange_follow", () => {
        this.getTableData();
      }),
      this.getTableData();
    //监听submitFormEditchange事件，如果数据发送变化，就调取getTableData函数重新加载数据。
    // this.$bus.$on("change_patrol_reminder_create", data => {
    //   console.log("11111111");
    //   console.log(data, "11111111");
    //   // this.dialogFormVisible = false
    //   // 每次点击进来初始化数据,弹出弹窗
    //   this.objData = data;
    //   this.form = Object.assign({}, data.content);
    //   setTimeout(() => {
    //     this.dialogFormVisible = true;
    //   }, 500);
    // });
  },
  components: { iTable },
};
</script>
<style lang="scss" scoped>
.followlist {
  .followlist-m {
    padding: 10px 0 0 5px;
  }
}

// 修改element-ui默认的样式
.del {
  color: red !important;
}
.fangqu {
  color: green !important;
}
.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}
//  ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}

//新增的dialog
@media screen and (min-width: 1200px) {
  ::deep .followxz .el-dialog {
    width: 30% !important;
  }
}

//修改的dialog
@media screen and (min-width: 1200px) {
  ::deep .followedit .el-dialog {
    width: 30% !important;
  }
}
</style>
